module.exports = __webpack_public_path__ + "static/media/logo.7959bb0c.svg";